import {combineReducers} from 'redux'
import {groupReducer} from "./groupReducer";
import {initialDataReducer} from "./initialDataReducer";

const accountCreationReducer = combineReducers({
    group: groupReducer,
    initialData: initialDataReducer,
});

export default accountCreationReducer;